import { render, staticRenderFns } from "./serverRolePaidTierLevelDetails.vue?vue&type=template&id=aebec6fc&scoped=true&"
import script from "./serverRolePaidTierLevelDetails.vue?vue&type=script&lang=js&"
export * from "./serverRolePaidTierLevelDetails.vue?vue&type=script&lang=js&"
import style0 from "./serverRolePaidTierLevelDetails.vue?vue&type=style&index=0&id=aebec6fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aebec6fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aebec6fc')) {
      api.createRecord('aebec6fc', component.options)
    } else {
      api.reload('aebec6fc', component.options)
    }
    module.hot.accept("./serverRolePaidTierLevelDetails.vue?vue&type=template&id=aebec6fc&scoped=true&", function () {
      api.rerender('aebec6fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/serverRolePaidTierLevelDetails.vue"
export default component.exports